import {useState, useRef, useCallback, useEffect} from 'react';

interface IHookActions {
    showNotification: boolean;
    notificationText: string;
    notificationValue: boolean;
    onNotificationChange: (value:boolean) => void;
    onNotificationDestory: () => void;
    notificationCallback: ({content}: {content:string}) => Promise<any>;
    setShowNotification: (value: boolean) => void;
    resetState: () => void;
}
interface IHookProps {
    getNotificationConfig: (builderId: string) => Promise<void>;
    setNotificationConfig: (builderId:string, status: 0 | 1) => Promise<void>;
    builderId: string;
}
export const useNotificationHook = (props: IHookProps): IHookActions => {
    const {getNotificationConfig, setNotificationConfig, builderId} = props;
    const notificationRef = useRef<any>({
        resolve: null,
        reject: null,
    });
    const timer = useRef<any>(null);
    const [showNotification, setShowNotification] = useState(false);
    const [notificationText, setNotificationText] = useState('');
    const [notificationValue, setNotificationValue] = useState(false);

    useEffect(() => {
        if (!showNotification) {
            return;
        }
        getNotificationConfig(builderId).then((res:any) => {
            const value = res.status === 1;
            setNotificationValue(value);
        });
    }, [builderId, getNotificationConfig, showNotification]);

    const resetState = useCallback(() => {
        setShowNotification(false);
        setNotificationText('');
        setNotificationValue(false);
    }, []);

    const onNotificationChange = useCallback((value:boolean) => {
        setNotificationValue(value);
        clearTimeout(timer.current);
        timer.current = null;
        timer.current = setTimeout(() => {
            const status = value ? 1 : 0;
            setNotificationConfig(builderId, status);
        }, 300);
    }, [builderId, setNotificationConfig]);

    const onNotificationDestory = useCallback(() => {
        setShowNotification(false);
        if (!notificationRef.current?.resolve) {
            return;
        }
        notificationRef.current.resolve({
            status: notificationValue ? 'accept' : 'reject',
        });
    }, [notificationValue, notificationRef]);

    const notificationCallback = useCallback(({content}: {content: string}) => {
        setNotificationText(content);
        setShowNotification(true);
        return new Promise((resolve, reject) => {
            notificationRef.current.resolve = resolve;
            notificationRef.current.reject = reject;
        });
    }, [notificationRef]);

    return {
        showNotification,
        notificationText,
        notificationValue,
        onNotificationChange,
        onNotificationDestory,
        notificationCallback,
        setShowNotification,
        resetState,
    };
};
